var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 50H5.625C2.525 50 0 47.475 0 44.375V23.125C0 20.025 2.525 17.5 5.625 17.5H34.375C37.475 17.5 40 20.025 40 23.125V30.625C40 31.66 39.16 32.5 38.125 32.5C37.09 32.5 36.25 31.66 36.25 30.625V23.125C36.25 22.0925 35.4075 21.25 34.375 21.25H5.625C4.5925 21.25 3.75 22.0925 3.75 23.125V44.375C3.75 45.4075 4.5925 46.25 5.625 46.25H28.125C29.16 46.25 30 47.09 30 48.125C30 49.16 29.16 50 28.125 50Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 21.25C29.59 21.25 28.75 20.41 28.75 19.375V12.5C28.75 7.675 24.825 3.75 20 3.75C15.175 3.75 11.25 7.675 11.25 12.5V19.375C11.25 20.41 10.41 21.25 9.375 21.25C8.34 21.25 7.5 20.41 7.5 19.375V12.5C7.5 5.6075 13.1075 0 20 0C26.8925 0 32.5 5.6075 32.5 12.5V19.375C32.5 20.41 31.66 21.25 30.625 21.25Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.125 45H53.125C52.09 45 51.25 44.16 51.25 43.125C51.25 42.09 52.09 41.25 53.125 41.25H56.25V38.125C56.25 37.09 57.09 36.25 58.125 36.25C59.16 36.25 60 37.09 60 38.125V43.125C60 44.16 59.16 45 58.125 45Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.875 58.75C35.84 58.75 35 57.91 35 56.875V51.875C35 50.84 35.84 50 36.875 50H41.875C42.91 50 43.75 50.84 43.75 51.875C43.75 52.91 42.91 53.75 41.875 53.75H38.75V56.875C38.75 57.91 37.91 58.75 36.875 58.75Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.35 46.25C37.17 46.25 36.985 46.2225 36.805 46.17C35.815 45.8675 35.255 44.82 35.555 43.83C37.1625 38.5475 41.9625 35 47.5 35C52.125 35 56.3425 37.5375 58.5075 41.62C58.99 42.535 58.6425 43.67 57.7275 44.1575C56.805 44.635 55.6775 44.2925 55.19 43.3775C53.6825 40.5225 50.7325 38.75 47.5 38.75C43.625 38.75 40.2675 41.23 39.145 44.92C38.9 45.73 38.155 46.25 37.35 46.25Z",
    fill: "#156981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 60C42.875 60 38.6575 57.4625 36.4925 53.38C36.01 52.465 36.3575 51.33 37.2725 50.8425C38.1925 50.3625 39.3225 50.7075 39.81 51.6225C41.3175 54.4775 44.2675 56.25 47.5 56.25C51.3525 56.25 54.7125 53.7675 55.86 50.0675C56.1675 49.08 57.215 48.525 58.205 48.835C59.195 49.14 59.745 50.1925 59.4375 51.18C57.8025 56.455 53.005 60 47.5 60Z",
    fill: "#156981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockReset);
export default __webpack_public_path__ + "static/media/lock-reset.26c6d6f3ddda78a8c9d9b3a84ee7c8bf.svg";
export { ForwardRef as ReactComponent };